export default __webpack_public_path__ + "static/desk06-9560da7e692d25a960c08716ce1b2727.png";